import { render, staticRenderFns } from "./MetricItem.vue?vue&type=template&id=6b87ac2c"
import script from "./MetricItem.vue?vue&type=script&lang=js"
export * from "./MetricItem.vue?vue&type=script&lang=js"
import style0 from "./MetricItem.vue?vue&type=style&index=0&id=6b87ac2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports